import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import useScreen from 'hooks/useScreen';
const QuickViewModalDesktop = loadable(() => import('./components/QuickViewModalDesktop'));
const QuickViewModalMobile = loadable(() => import('./components/QuickViewModalMobile'));
const QuickViewModalUI = t0 => {
  const $ = _c(11);
  const {
    description,
    dimensions,
    isOpen,
    name,
    onClose,
    onMoreMaterialsClick,
    path,
    slug,
    isOutOfStock
  } = t0;
  const {
    isMobile
  } = useScreen();
  let t1;
  if ($[0] !== description || $[1] !== dimensions || $[2] !== isMobile || $[3] !== isOpen || $[4] !== isOutOfStock || $[5] !== name || $[6] !== onClose || $[7] !== onMoreMaterialsClick || $[8] !== path || $[9] !== slug) {
    t1 = isMobile ? <QuickViewModalMobile dimensions={dimensions} isOpen={isOpen} name={name} onClose={onClose} onMoreMaterialsClick={onMoreMaterialsClick} path={path} slug={slug} isOutOfStock={isOutOfStock} /> : <QuickViewModalDesktop description={description} dimensions={dimensions} isOpen={isOpen} name={name} onClose={onClose} onMoreMaterialsClick={onMoreMaterialsClick} path={path} slug={slug} isOutOfStock={isOutOfStock} />;
    $[0] = description;
    $[1] = dimensions;
    $[2] = isMobile;
    $[3] = isOpen;
    $[4] = isOutOfStock;
    $[5] = name;
    $[6] = onClose;
    $[7] = onMoreMaterialsClick;
    $[8] = path;
    $[9] = slug;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
};
QuickViewModalUI.propTypes = {
  description: PropTypes.string,
  dimensions: PropTypes.string,
  isOpen: PropTypes.bool,
  name: PropTypes.string,
  onClose: PropTypes.func,
  onMoreMaterialsClick: PropTypes.func,
  path: PropTypes.string,
  slug: PropTypes.string,
  isOutOfStock: PropTypes.bool
};
export default QuickViewModalUI;